import API from './API'

export const getAccumulationConditions = async () => {
  return await API.get('/accumulation-conditions')
}
